import {
  createBackground,
  getCreativeView,
  getRandomCreativeAsset,
  renderCreativeView,
} from './core';
import { preloadImages } from '../lib/utils';
import { Pet, PetSpecies } from 'src/replicant/buruburu/pet';
import StateObserver from 'src/StateObserver';

const creativesMap: Record<PetSpecies, string> = {
  ball: 'energysent_ball.png',
  crab: 'energysent_crab.png',
  dog: 'energysent_dog.png',
  starball: 'energysent_starball.png',
  hamster: 'energysent_hamster.png',
  turtle: 'energysent_turtle.png',
  seaotter: 'energysent_seaotter.png',
  cat: 'energysent_cat.png',
  whale: 'energysent_whale.png',
  giraffe: 'energysent_giraffe.png',
};

/**
 * Choose random creative for ab test
 */
export function getRandomGiftEnergyCreative() {
  return getRandomCreativeAsset(
    '22-06-21', // Creative prefix, test start date
    [() => createDefaultEnergyGift('energy_gift_default')],
  );
}

/**
 * Default energy gift creative
 */
async function createDefaultEnergyGift(id: string) {
  const superview = getCreativeView(720, 477);

  // Get current pet species
  const state = StateObserver.getState().user;
  const species = Pet.getters(state).getCurrentEvolution().species;

  const image = `assets/creatives/gifts/${creativesMap[species]}`;

  await preloadImages([image]);

  createBackground({ superview, image });

  return renderCreativeView(id, superview);
}
